import type { AppRouteModule } from '/@/router/types';

import { t } from '/@/hooks/web/useI18n';
import { LAYOUT } from '/@/router/constant';

/**
 * 'carton-manage': '纸箱管理',
 */
const route: AppRouteModule = {
  path: '/carton-manage',
  name: 'CartonManage',
  component: LAYOUT,
  redirect: '/carton-manage/inventory-and-shipping-status',
  meta: {
    icon: 'ic:sharp-my-location',
    title: t('routes.carton-manage.main'),
    orderNo: 20010,
    roles: [20225503],
  },
  children: [
    /**
     * 'inventory-and-shipping-status': '库存及发货情况反馈',
     */
    {
      path: 'inventory-and-shipping-status',
      name: 'InventoryAndShippingStatus',
      component: () => import('/@/views/carton-manage/inventory-and-shipping-status/index.vue'),
      meta: {
        title: t('routes.carton-manage.inventory-and-shipping-status'),
        roles: [20225504],
      },
    },
  ],
};

export default route;
